import ZoneForm              from 'scripts/defa/zones/view-zone-form';
import { Vue }               from 'vue/defavue';
import template              from './template-zone-preset-form.jst.html';

/**
 * ZonePresetForm
 * A view for changing zone presets
 * @version 1.3.0
 */


const channel = Bb.Radio.channel( 'objects' );

const ZonePresetForm = ZoneForm.extend( {
	
	// ----------------------------------
	// setup
	// ----------------------------------
	
	template : template,
	className: 'card change-preset',
	
	
	// !TODO Figure out what is causing te formenabler not working correctly and remove the disableSubmit and enableSubmit function calls from this view, should just rund the verifyform on input
	onAttach: function(){
		this.attachVueElements();
	},
	
	getComfortDay:function(){
		switch ( this.model.getModel('5').get('zoneMode') ) {
			case 'regulator':
				return this.model.getModel('4').get('occupiedLevel');
			case 'thermostat':
				return this.model.getModel('3').get('occupiedCoolingSetpoint');
		}
		return '';
	},
	
	getComfortNight:function(){
		switch ( this.model.getModel('5').get('zoneMode') ) {
			case 'regulator':
				return this.model.getModel('4').get('nightLevel');
			case 'thermostat':
				return this.model.getModel('3').get('nightCoolingSetpoint');
		}
		return '';
	},
	
	
	getSaving:function(){
		switch ( this.model.getModel('5').get('zoneMode') ) {
			case 'regulator':
				return this.model.getModel('4').get('unoccupiedLevel');
			case 'thermostat':
				return this.model.getModel('3').get('unoccupiedHeatingSetpoint');
		}
		return '';
	},
	
	/**
	 * Return true if nightmode is activated
	 * @boolean
	 */
	getNightmode:function(){
		return !!channel.request('dayAndNightSettings').get(this.model.get('unitId')).get('nightModeEnabled')
	},
	
	// ----------------------------------
	// other functions
	// ----------------------------------
	
	attachVueElements: function() {
		let self   = this;
		let valueDay = this.getComfortDay();
		let valueNight = this.getComfortNight();
		let valueSaving = this.getSaving();
		let [ min, max ] = 'regulator' === self.model.getModel( '5' ).get( 'zoneMode' ) ? [ 5, 95 ] : [ -20, 40 ];
		let tempUnit = self.model.tempUnit();
		
		new Vue( {
			el: '#preset-vue-components',
			bb() {
				return {
					thermostatModel : self.model.getModel( '3' ),
					regulatorModel  : self.model.getModel( '4' ),
					heatingZoneModel: self.model.getModel( '5' )
				};
			},
			data() {
				return {
					isNightModeActivated: self.getNightmode(),
					valueDay            : valueDay,
					valueNight          : valueNight,
					valueSaving         : valueSaving,
					valueUnit           : tempUnit,
					min,
					max,
					locked              : !self.options.enabled,
				};
			},
			
			watch : {
				'regulatorModel.occupiedLevel' : function (newValue){
					if(this.mode === 'regulator'){
						this.valueDay = newValue;
					}
				},
				'regulatorModel.nightLevel' : function (newValue){
					if(this.mode === 'regulator'){
						this.valueNight = newValue;
					}
				},
				'regulatorModel.unoccupiedLevel' : function (newValue){
					if(this.mode === 'regulator'){
						this.valueSaving = newValue;
					}
				},
				'thermostatModel.occupiedCoolingSetpoint' : function (newValue){
					if(this.mode === 'thermostat'){
						this.valueDay = newValue;
					}
				},
				'thermostatModel.nightCoolingSetpoint' : function (newValue){
					if(this.mode === 'thermostat'){
						this.valueNight = newValue;
					}
				},
				'thermostatModel.unoccupiedHeatingSetpoint' : function (newValue){
					if(this.mode === 'thermostat'){
						this.valueSaving = newValue;
					}
				}
			},
			
			methods: {
				saveUnoccupied: function () {
					let data = {};
					let savingValue = parseInt(this.valueSaving)
					switch (this.mode) {
						case 'regulator':
							data.unoccupiedLevel = savingValue;
							self.saveModel('4', data);
							break;
						case 'thermostat':
							data.unoccupiedHeatingSetpoint =   savingValue;
							data.unoccupiedCoolingSetpoint =  savingValue + 2;
							self.saveModel('3', data);
							break;
					}
				},
				saveOccupied: function () {
					let data = {};
					let savingValue = parseInt(this.valueDay)
					switch (this.mode) {
						case 'regulator':
							data.occupiedLevel = savingValue;
							self.saveModel('4', data);
							break;
						case 'thermostat':
							data.occupiedCoolingSetpoint =   savingValue;
							data.occupiedHeatingSetpoint =  savingValue - 1;
							self.saveModel('3', data);
							break;
					}
				},
				saveNight: function () {
					let data = {};
					let savingValue = parseInt(this.valueNight)
					switch (this.mode) {
						case 'regulator':
							data.nightLevel = savingValue;
							self.saveModel('4', data);
							break;
						case 'thermostat':
							data.nightCoolingSetpoint =   savingValue;
							data.nightHeatingSetpoint =  savingValue - 1;
							self.saveModel('3', data);
							break;
					}
				}
				
			},
			
			computed: {
				disableSlider : function () {
					return null === this.heatingZoneModel.zoneMode
				},
				modelError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.modelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.thermostatModel.modelError
					}
					return ''
				},
				dayError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.occupiedLevelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.thermostatModel.occupiedCoolingSetpointError
					}
					return ''
				},
				nightError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.nightLevelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.thermostatModel.nightCoolingSetpointError
					}
					return ''
				},
				savingError: function () {
					if('regulator' === this.heatingZoneModel.zoneMode) {
						return this.regulatorModel.unoccupiedLevelError
					} else if ('thermostat' === this.heatingZoneModel.zoneMode ){
						return this.thermostatModel.unoccupiedHeatingSetpointError
					}
					return ''
				},
				mode: function () {
					return this.heatingZoneModel.zoneMode
				}
			}
		});
	},
	
	saveModel: function (model, attrs) {
		let self = this;
		self.busy();
		try {
			self.model.getModel(model).save( attrs, {
				patch: true,
				isSaving: true,
				success: function () {
					console.log( Object.keys(attrs)[0] +' was succesfully saved!' );
					self.idle();
					self.model.getModel(model).updateCurrent()
				},
				error  : function (model, response) {
					console.error( Object.keys(attrs)[0] + ' failed saving with error: ' + response.responseJSON.message );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	
} );

export default ZonePresetForm;
